"use strict";

import Circle from "ol/geom/Circle";

/**
 * @namespace
 */
gc.gis.style = gc.gis.style || {};

/**
 * @classdesc
 * Style-Kreis-Implementierung auf Basis der Openlayers Kartenbibliothek.
 *
 * @class
 * @abstract
 * @extends gc.gis.GCWrappable
 * @memberof gc.gis.style
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.style.OLCircle = function()
{
    gc.gis.style.GCCircle.call(this);

    /** @type {number} */
    this.radius = 5;
    /** @type {gc.gis.style.GCFill} */
    this.fill = undefined;
    /** @type {gc.gis.style.GCStroke} */
    this.stroke = undefined;
};
gc.gis.style.OLCircle.prototype = Object.create(gc.gis.style.GCCircle.prototype);

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.setRadius = function(radius)
{
    this.radius = radius;
    return this;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.getRadius = function()
{
    return this.radius;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.getImpl = function()
{
    const opts = {
        radius: this.radius
    };
    if (this.fill) {
        opts.fill = this.fill.getImpl();
    }
    if (this.stroke) {
        opts.stroke = this.stroke.getImpl();
    }

    return new Circle(opts);
};

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.setFill = function(fill)
{
    this.fill = fill;
    return this;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.getFill = function ()
{
    return this.fill;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.setStroke = function (stroke)
{
    this.stroke = stroke;
    return this;
};

/**
 * @inheritDoc
 */
gc.gis.style.OLCircle.prototype.getStroke = function ()
{
    return this.stroke;
};